const actionTypes = {
    CHANGE_LAYOUT: 'CHANGE_LAYOUT',
    CHANGE_LAYOUT_WIDTH: 'CHANGE_LAYOUT_WIDTH',
    CHANGE_SIDEBAR_THEME: 'CHANGE_SIDEBAR_THEME',
    CHANGE_SIDEBAR_TYPE: 'CHANGE_SIDEBAR_TYPE',
    TOGGLE_RIGHT_SIDEBAR: 'TOGGLE_RIGHT_SIDEBAR',
    SHOW_RIGHT_SIDEBAR: 'SHOW_RIGHT_SIDEBAR',
    HIDE_RIGHT_SIDEBAR: 'HIDE_RIGHT_SIDEBAR',
    INIT_MENU: 'INIT_MENU',
    INIT_MENU_SUCCESS: 'INIT_MENU_SUCCESS',
    CHANGE_ACTIVE_MENU_FROM_LOCATION: 'CHANGE_ACTIVE_MENU_FROM_LOCATION',
    CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS: 'CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS',
    GET_APPLICATION_ROUTES_SUCCESS: 'GET_APPLICATION_ROUTES_SUCCESS',
    SET_BLOCK_REF_DATA_ROUTES: 'SET_BLOCK_REF_DATA_ROUTES',
    SET_BLOCK_RECON_ROUTES: 'SET_BLOCK_RECON_ROUTES',
    GET_APPLICATION_DASHBOARD: 'GET_APPLICATION_DASHBOARD',
};

export default actionTypes;
